var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-default',{ref:"commEmailModal",attrs:{"subtitle":"EMAIL","title":_vm.contact.full_name,"width":1000}},[_c('keep-alive',[_c(_vm.commEmailComponent,_vm._b({tag:"component"},'component',_vm.currentProps,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }